import React from "react";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { useI18n } from "../i18n";
import ProductCard from "../components/ProductCard";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function Wishlist() {
  const { wishlist } = useCart();
  const { t } = useI18n();

  return (
    <div className="min-h-screen pb-20" data-testid="wishlist-page">
      <div className="gf-container py-10">
        <h1 className="font-display text-3xl lg:text-4xl font-bold text-slate-900 mb-8">{t("common.wishlist")}</h1>
        {wishlist.length === 0 ? (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="rounded-3xl bg-white border border-slate-200 p-16 text-center">
            <Heart className="w-12 h-12 text-[#A855F7]/40 mx-auto mb-4" />
            <p className="text-slate-700 font-medium">{t("common.empty_wishlist")}</p>
            <Link to="/catalog"><Button className="btn-neon rounded-full px-6 mt-5">{t("common.explore_now")}</Button></Link>
          </motion.div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {wishlist.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
